module.exports = __webpack_public_path__ + "img/ricelog_pinicon_040.50767ec9.png";